import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { GroupsApplicationsState } from './types';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: GroupsApplicationsState = {
  groupsApplications: [],
};

export const groupsApplications: Module<GroupsApplicationsState, RootState> = {
  state,
  getters,
  actions,
  mutations
};
